import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import cssModules from "react-css-modules";
import { FormattedMessage, injectIntl } from "react-intl";
import Alert from "react-s-alert";
import LocaleDropdown from './language-dropdown';



const Header = ({ locale, setLocale, intl, route }) => {
  const hideNav = document.location.pathname.includes('speaker-data');

  return (
    <React.Fragment>
      <Navbar
        id="nav-new"
        expand="lg"
        fixed="top"
        collapseOnSelect
        variant="light"
      >
        <Container>
          <Navbar.Brand>
            <div className="navbar-header">
              <a className="logo navbar-brand" href={process.env.REACT_APP_WP_SITE_ROOT}>
                <img src="/images/logo.png" alt="eSlides Logo" />
              </a>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="justify-content-end"
          >
            <ul className="ml-auto navbar-nav">
              {
                !hideNav &&
                <>
                  <Nav.Item><Nav.Link className="nav-link text-uppercase" href={`${process.env.REACT_APP_WP_SITE_ROOT}/tarifs`}>Tarifs</Nav.Link></Nav.Item>
                  <Nav.Item><Nav.Link className="nav-link text-uppercase" href={`${process.env.REACT_APP_WP_SITE_ROOT}/contact`}>Contact</Nav.Link></Nav.Item>
                  <Nav.Item className="login"><Nav.Link className="nav-link text-uppercase" href="/"><FormattedMessage id="link.login" /></Nav.Link></Nav.Item>
                  <Nav.Item className="login"><Nav.Link className="nav-link text-uppercase" href="/signup"><FormattedMessage id="link.register" /></Nav.Link></Nav.Item>
                </>
              }
              <LocaleDropdown locale={locale} setLocale={setLocale} />
              <Navbar.Toggle>
                <img src="/icons/close.png" alt="close" />
              </Navbar.Toggle>
            </ul>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Alert stack={{ limit: 1 }} offset={40} />
    </React.Fragment>
  );
};

export default cssModules(injectIntl(Header));
